import React from 'react';
import Roadsafety  from 'views/Roadsafety';

const ClassAssemblyPage = () => {
    return <Roadsafety />;
  };
  
  export default ClassAssemblyPage;